import {CSSTransition} from 'react-transition-group'
import {useCallback, useEffect} from 'react'
import {LoadingPage} from '../../../_gori/helpers/components/LoadingPage'
import {useNavigate, useSearchParams} from 'react-router-dom'
import SettingsService from '../../modules/settings/core/_requests'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {OrderType} from '../../modules/orders/core/_const'
import {isEmpty} from 'lodash'
import {ROUTES} from '../../../_gori/constants'
import {StorageHelpers} from '../../../_gori/helpers'
import {EBAY_SHIP_FROM_STORAGE_KEY} from '../../modules/settings/components/store/connections/ebay/ConnectEbay'

export function EbayVerifyPage() {
  const intl = useIntl()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const connectEbay = useCallback(async () => {
    const shipFrom = StorageHelpers.getItemLocalStorage(EBAY_SHIP_FROM_STORAGE_KEY) || {}
    const requestPayload = {
      store_type: OrderType.EBAY,
      code: searchParams.get('code'),
      ...shipFrom,
    }
    try {
      const res = await SettingsService.connect(requestPayload)
      if (res) {
        StorageHelpers.setItemLocalStorage('cardstore', {hidden: true})
        window.dispatchEvent(new Event('storage'))
        toast.success(intl.formatMessage({id: 'CONNECTION_SUCCESSFUL'}))
      }
    } catch (error: any) {
      let message = error?.response?.data?.error?.message ?? ''
      toast.error(isEmpty(message) ? intl.formatMessage({id: 'CONNECTION_FAILED'}) : message)
    } finally {
      StorageHelpers.removeItemLocalStorage(EBAY_SHIP_FROM_STORAGE_KEY)
      navigate(ROUTES.SETTINGS.CONNECTIONS.EBAY)
    }
  }, [intl, searchParams, navigate])

  useEffect(() => {
    connectEbay()
  }, [connectEbay])

  return (
    <CSSTransition appear in timeout={100} classNames='fade' unmountOnExit>
      <LoadingPage />
    </CSSTransition>
  )
}
